import { type BulkAction, type RowAction } from '../models/actions';
import { type IconResolverService } from '../page/icon-resolver.service';

export function resolveActionIcons(
  actionLists: (RowAction[] | BulkAction[] | undefined)[],
  resolver: IconResolverService,
): void {
  actionLists.forEach((actions) => {
    actions?.forEach((action) => {
      if (action.$type === 'custom' && action.iconName) {
        action.iconName = resolver.resolveFullIconName(action.iconName);
      }
    });
  });
}
